// Bumped automatically pelo hook .husky/pre-push (ver scripts/bump-app-version.mjs).
// Não editar o número à mão — mexe só se precisares de reset manual da versão.
export const APP_VERSION = '2.0.30';
